import React from 'react';
import './Blogs.css';
import { useNavigate } from 'react-router-dom';

// Datos de ejemplo
const blogPosts = [
    {
        id: 1,
        title: "¿Qué es un Agente de IA y por qué necesitas uno?",
        image: "/imagenes_blogs/miniatura_blog1.png",
        slug: "blogs/que-es-agente-ia"
    },
    {
        id: 2,
        title: "Cómo n8n revoluciona la automatización con IA",
        image: "/imagenes_blogs/miniatura_blog2.png",
        slug: "blogs/despliegue-rapido-n8n"
    },
    {
        id: 3,
        title: "Roadmap hacia la automatización inteligente",
        image: "/imagenes_blogs/miniatura_blog3.png",
        slug: "blogs/estrategia-automatizacion"
    },
    {
        id: 4,
        title: "El futuro de la IA Industrial en 2026",
        image: "/imagenes_blogs/miniatura_blog4.png",
         slug: "blogs/futuro-industrial"
    },
    {
        id: 5,
        title: "Clawdbot (Moltbot): El Agente de IA que controla tu ordenador",
        image: "/imagenes_blogs/miniatura_blog5.png",
         slug: "blogs/ClawbotAnalisis"
    },
    {
        id: 6,
        title: "El Aliado Invisible: La Simbiosis Humano-IA",
        image: "/imagenes_blogs/miniatura_blog6.png",
         slug: "blogs/AliadoInvisible"
    },
    {
        id: 7,
        title: "El Poder de la IA Localizada",
        image: "/imagenes_blogs/miniatura_blog7.png",
         slug: "blogs/IaLocalizada"
    },
    {
        id: 8,
        title: "El Impacto de Claude Code en la producción",
        image: "/imagenes_blogs/miniatura_blog8.png",
         slug: "blogs/ImpactoClaudeCode"
    }/*,
    {
        id: 4,
        title: "El titulo del blog",
        image: "/imagenes_blogs/imagen del blog",
        slug: "blogs/nombre del blog en el codigo"
    },
    {
        id: 4,
        title: "El titulo del blog",
        image: "/imagenes_blogs/imagen del blog",
        slug: "blogs/nombre del blog en el codigo"
    },*/

];

export default function Blog() {
    const navigate = useNavigate();

    const handlePostClick = (slug) => {
        // Aquí redirigimos al artículo individual.
        // De momento, como no tenemos esa página creada, redirigirá pero dará error 404 o blanco.
        navigate(`/${slug}`);
    };

    return (
        <div className="blog-container">
            <h1 className="blog-main-title">Blog de Navi</h1>
            <p className="blog-subtitle">Novedades sobre automatización e inteligencia artificial.</p>

            <div className="blog-grid">
                {blogPosts.map((post) => (
                    <article
                        key={post.id}
                        className="blog-card"
                        onClick={() => handlePostClick(post.slug)}
                    >
                        {/* Imagen (2/3 superior) */}
                        <div
                            className="blog-card-image"
                            style={{ backgroundImage: `url(${post.image})` }}
                        ></div>

                        {/* Contenido (1/3 inferior) */}
                        <div className="blog-card-content">
                            <h3>{post.title}</h3>
                            <span className="read-more">Leer más &rarr;</span>
                        </div>
                    </article>
                ))}
            </div>
        </div>
    );
}
